import React from "react";
import {AvailableMenu, Product} from "@/data/entities/menu";
import {ProductInfoProvider} from "@widgets/pos/order/menu/product/context/ProductInfoProvider";
import {placeholderProduct} from "@/data/entities/product/utils";
import ProductInfoModal from "@widgets/pos/order/menu/product/modal/ProductInfoModal";

type Props = {
    show: boolean,
    setShow: (show: boolean) => void,
    availableMenu: AvailableMenu,
    product: Product | null,
    setProduct: (product: Product) => void,
};

const ProductInfo = ({show, setShow, availableMenu, product, setProduct}: Props) => {
    return (
        <ProductInfoProvider
            availableMenu={availableMenu}
            // We use a placeholder product so, we can guarantee non-null &
            // mount for first show-in animation:
            product={product || placeholderProduct}
            setProduct={setProduct}
            show={show}
            setShow={setShow}
        >
            <ProductInfoModal/>
        </ProductInfoProvider>
    );
};

export default ProductInfo;